import $ from 'jquery';
import mainMenu from './mainMenu';

$(() => {
    mainMenu();
});
